import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { ArticleCard } from "@/components/news/ArticleCard";
import { OverlayCard } from "@/components/news/OverlayCard";
import { SectionTitle } from "@/components/news/SectionTitle";
import { Button } from "@/components/ui/button";

export const ArticleFeed = ({ params, title, testId, emptyText = "Aucun article pour le moment." }) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [sort, setSort] = useState("recent");
  const [loading, setLoading] = useState(true);
  const paramsKey = JSON.stringify(params);
  const stableParams = useMemo(() => JSON.parse(paramsKey), [paramsKey]);

  useEffect(() => {
    setLoading(true);
    api.get("/articles", { params: { ...stableParams, sort, limit: 12 } })
      .then((r) => { setItems(r.data.items); setTotal(r.data.total); })
      .catch((error) => console.error("Feed error:", error))
      .finally(() => setLoading(false));
  }, [stableParams, sort]);

  const more = () => api.get("/articles", { params: { ...stableParams, sort, limit: 12, skip: items.length } }).then((r) => setItems([...items, ...r.data.items]));
  const [first, ...rest] = items;

  return (
    <div data-testid={testId}>
      <SectionTitle right={
        <div className="flex text-xs font-bold uppercase tracking-wider">
          {[["recent", "Récent"], ["popular", "Populaire"]].map(([k, l]) => <button key={k} data-testid={`sort-${k}`} onClick={() => setSort(k)} className={`px-3 py-1 border ${sort === k ? "bg-[#111827] text-white border-[#111827]" : "bg-white text-zinc-600 border-zinc-300 hover:border-zinc-500"} transition-colors`}>{l}</button>)}
        </div>
      }>{title} <span className="text-zinc-400 font-normal normal-case text-sm ml-2">{total} article{total > 1 ? "s" : ""}</span></SectionTitle>
      {loading ? <div className="h-64 bg-white/60 animate-pulse" /> : !items.length ? <p className="text-zinc-500 py-10 text-center bg-white border" data-testid="feed-empty">{emptyText}</p> : (
        <>
          <OverlayCard article={first} size="lg" testId="feed-first" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">{rest.map((a) => <ArticleCard key={a.id} article={a} />)}</div>
          {items.length < total && <div className="text-center mt-8"><Button data-testid="load-more-btn" onClick={more} variant="outline" className="rounded-none border-[#111827] font-bold uppercase text-xs tracking-wider hover:bg-[#111827] hover:text-white">Charger plus</Button></div>}
        </>
      )}
    </div>
  );
};

export default function Rubrique() {
  const { slug } = useParams();
  const { catName } = useSettings();
  return <ArticleFeed key={slug} params={{ category: slug }} title={catName(slug)} testId={`rubrique-page-${slug}`} />;
}
